<template>
    <div class="reports-table">
        <div class="reports-table__actions">
            <div class="reports-table__filter">
                <!-- eslint-disable vue/no-deprecated-v-bind-sync -->
                <v-autocomplete
                    v-model="filters.client.value"
                    :search-input.sync="search"
                    :items="filtersItems.clients"
                    :loading="clientsIsFetching"
                    dense
                    :label="$t('pages.report.client')"
                    hide-details
                    hide-no-data
                    placeholder="Client"
                ></v-autocomplete>
            </div>
            <div class="reports-table__filter">
                <v-autocomplete
                    v-model="filters.user.value"
                    :items="filtersItems.users"
                    dense
                    :label="$t('pages.report.employee')"
                    hide-details
                    placeholder="Employee"
                ></v-autocomplete>
            </div>
            <div class="reports-table__filter">
                <v-autocomplete
                    v-model="filters.source.value"
                    :items="filters.source.items"
                    dense
                    :label="$t('pages.report.source')"
                    hide-details
                    placeholder="Source"
                ></v-autocomplete>
            </div>
        </div>
        <div class="reports-table__table">
            <v-data-table
                :headers="headers"
                :items="filteredPayments"
                :items-per-page="-1"
                :footer-props="{
                    'items-per-page-text': $t('pages.report.rowsPerPage'),
                }"
                class="elevation-1"
                :search="search"
                :no-data-text="$t('pages.report.noDataAvailable')"
                :custom-filter="filterOnlyCapsText"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                dense
                hide-default-footer
                multi-sort
                @click:row="clickHandle"
                @update:sort-by="updateSortBy"
                @update:sort-desc="updateSortDesc"
            >
                <!--    eslint-disable-next-line -->
                <template #body.append="{ headers }">
                    <tr class="reports-table__totally-row">
                        <td :colspan="headers.length - 1">
                            <p class="reports-table__totally">
                                {{ $t('pages.report.totally') }}
                            </p>
                        </td>
                        <td :colspan="1">{{ totally }}</td>
                    </tr>
                </template>
                <!--    eslint-disable-next-line -->
                <template #item.is_repair_wig="{ item }">
                    <template v-if="item.is_repair_wig">
                        <v-icon small color="red">mdi-wrench</v-icon>
                    </template>
                </template>

                <!--    eslint-disable-next-line -->
                <template #item.remainder="{ item }">
                    <div
                        v-if="item?.remainder"
                        class="reports-table__reminder"
                        :class="getColor(item.status)"
                    >
                        {{ item.remainder }}
                    </div>
                    <span v-else>-</span>
                </template>

                <!--    eslint-disable-next-line -->
                <template #item.source="{ item }">
                    <div>
                        {{ $t(`pages.report.${toCamelCase(item.source)}`) }}
                    </div>
                </template>
                <!--    eslint-disable-next-line -->
                <template #item.created_at="{ item }">
                    <span style="direction: ltr; display: inline-block">
                        <DateCell :value="item.created_at" />
                    </span>
                </template>
                <!--    eslint-disable-next-line -->
                <template #item.status="{ item }">
                    <template v-if="item.remainder">
                        <v-progress-circular
                            :rotate="270"
                            :size="20"
                            :width="5"
                            :value="item.status"
                            :color="getColor(item.status)"
                        >
                        </v-progress-circular>
                    </template>
                    <template v-else>
                        <v-progress-circular
                            :rotate="270"
                            :size="20"
                            :width="5"
                            value="100"
                            color="#999"
                        >
                        </v-progress-circular>
                    </template>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
import languageMixin from '@/mixins/language.mixin'
import languageOrderExtraMixin from '@/mixins/language-order-extra.mixin'
import { mapActions, mapGetters } from 'vuex'
import { getterTypes } from '@/store/modules/report'
import { getterTypes as getterTypesUsers } from '@/store/modules/users'
import { getFullDayFirstFull } from '@/helpers/getDateInFormat'
import { actionTypes as actionTypesOrders } from '@/store/modules/orders'
import DateCell from '@/components/common/cells/date-cell.vue'
import wigTransitions from '@/helpers/transitions/wig-transitions'
import {
    clientsV2ActionTypes,
    clientsV2GetterTypes,
} from '@/store/modules/clients_v2/types'
import arraysEqual from '@/helpers/arrays-equal.helper'
import prepareSortOptionsReports from '@/helpers/prepare-sort-options-reports.utils'

export default {
    name: 'ReportsPaymentTable',
    components: { DateCell },
    mixins: [languageMixin, languageOrderExtraMixin],
    emits: ['sort-change', 'filters-change'],
    data() {
        return {
            key: '',
            search: '',
            preparedSortParams: '',
            sortBy: [],
            sortDesc: [],
            sortKeys: {
                created_at: 'created_at',
                amount: 'amount',
            },
            filters: {
                client: {
                    items: [
                        {
                            text: this.$t('pages.report.any'),
                            value: '',
                        },
                        {
                            text: 'Client 001',
                            value: 'client-001',
                        },
                        {
                            text: 'Client 002',
                            value: 'client-002',
                        },
                    ],
                    value: '',
                },
                user: {
                    items: [
                        {
                            text: this.$t('pages.report.any'),
                            value: '',
                        },
                    ],
                    value: '',
                },
                source: {
                    items: [
                        {
                            text: this.$t('pages.report.any'),
                            value: '',
                        },
                        {
                            text: this.$t('pages.report.card'),
                            value: 'Card',
                        },
                        {
                            text: this.$t('pages.report.cash'),
                            value: 'Cash',
                        },
                        {
                            text: this.$t('pages.report.payoutCheck'),
                            value: 'Payout check',
                        },
                        {
                            text: this.$t('pages.report.wireTransfer'),
                            value: 'Wire Transfer',
                        },
                        {
                            text: this.$t('pages.report.bankDirectDebit'),
                            value: 'Bank Direct Debit',
                        },
                    ],
                    value: '',
                },
            },
        }
    },
    computed: {
        ...mapGetters('report', {
            getAllPayments: getterTypes.getAllPayments,
        }),
        ...mapGetters('users', {
            getAllUsers: getterTypesUsers.getAllUsers,
        }),
        ...mapGetters('clientsV2', {
            getAllClients: clientsV2GetterTypes.GET_ITEMS,
            clientsIsFetching: clientsV2GetterTypes.GET_LOADING,
        }),
        textPayment: function () {
            return (
                this.getTextForSelected(this.lang, 'OrderModalDepositUpdate') ||
                ''
            )
        },
        totally: function () {
            return this.getAllPayments.totally ?? 0
        },
        headers: function () {
            return [
                {
                    text: this.$t('pages.report.kind'),
                    value: 'is_repair_wig',
                    align: 'center',
                    width: '1%',
                    sortable: false,
                },
                { text: this.textContent['created'], value: 'created_at' },
                {
                    text: this.textContent['client'],
                    value: 'client',
                    sortable: false,
                },
                {
                    text: this.textContent['barcode'],
                    value: 'barcode',
                    sortable: false,
                },
                {
                    text: this.$t('pages.report.employee'),
                    value: 'employee',
                    sortable: false,
                },
                {
                    text: this.$t('pages.report.source'),
                    value: 'source',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: this.textContent['amount'],
                    value: 'amount',
                    align: 'center',
                },
                {
                    text: this.$t('pages.report.remainder'),
                    value: 'remainder',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: this.$t('pages.report.status'),
                    value: 'status',
                    align: 'center',
                    sortable: false,
                },
            ]
        },
        filteredPayments: function () {
            return this.getAllPayments.payments ?? []
        },
        filtersItems: function () {
            const clients = this.getAllClients.map(({ full_name, id }) => ({
                text: full_name,
                value: id,
            }))
            const users = this.getAllUsers.map(({ nickName, id }) => ({
                text: nickName,
                value: id,
            }))
            return {
                clients: [
                    { text: this.$t('pages.report.any'), value: '' },
                    ...clients,
                ],
                users: [
                    { text: this.$t('pages.report.any'), value: '' },
                    ...users,
                ],
            }
        },
    },
    watch: {
        search: function (val) {
            const selected = this.filtersItems.clients.find(
                (c) => c.value === this.filters.client.value
            )

            const runSearch = () => {
                clearTimeout(this.searchQueryTimeout)
                this.searchQueryTimeout = setTimeout(() => {
                    this.setSearchQuery(val)
                }, 500)
            }

            if (val === '') {
                this.fetchClients()
                return
            }

            if (selected && selected.text !== val) {
                runSearch()
                return
            }

            if (!selected && val && val !== 'Any') {
                runSearch()
            }
        },
        filters: {
            handler() {
                this.$emit('filters-change', {
                    client: this.filters.client.value
                        ? [this.filters.client.value]
                        : [],
                    employee: this.filters.user.value
                        ? [this.filters.user.value]
                        : [],
                    source: this.filters.source.value
                        ? [this.filters.source.value]
                        : [],
                })
            },
            deep: true,
        },
        preparedSortParams: function () {
            this.emitSortChange()
        },
    },
    mounted() {
        this.setSearchQuery('')
    },
    methods: {
        ...mapActions('orders', {
            getOrder: actionTypesOrders.loadOrder,
        }),
        ...mapActions('clientsV2', {
            fetchClients: clientsV2ActionTypes.FETCH_ITEMS,
            setSearchQuery: clientsV2ActionTypes.SET_SEARCH_QUERY,
        }),
        dateFormat: function (date) {
            return getFullDayFirstFull(date)
        },
        filterOnlyCapsText() {
            return true
        },
        getColor: function (value) {
            return value >= 100 ? 'green' : value >= 50 ? 'orange' : 'red'
        },
        clickHandle: function (e) {
            if (e.wig_id) {
                wigTransitions.moveToWigPageInNewTab(e.wig_id)
            }
        },
        toCamelCase: function (str) {
            return str
                .toLowerCase()
                .split(' ')
                .map((word, index) => {
                    if (index === 0) {
                        return word
                    }
                    return word.charAt(0).toUpperCase() + word.slice(1)
                })
                .join('')
        },
        updateSortBy: function (value) {
            this.sortBy = value
            const newSortParams = prepareSortOptionsReports(
                this.sortBy,
                this.sortDesc,
                this.sortKeys
            )

            if (arraysEqual(this.preparedSortParams, newSortParams)) {
                return
            }

            this.preparedSortParams = newSortParams
        },
        updateSortDesc: function (value) {
            this.sortDesc = value
            const newSortParams = prepareSortOptionsReports(
                this.sortBy,
                this.sortDesc,
                this.sortKeys
            )

            if (arraysEqual(this.preparedSortParams, newSortParams)) {
                return
            }

            this.preparedSortParams = newSortParams
        },
        emitSortChange: function () {
            this.$emit('sort-change', this.preparedSortParams)
        },
    },
}
</script>

<style lang="scss" scoped>
.reports-table {
    &__totally-row {
        font-weight: 700;
        font-size: 1.1em;
    }
    &__totally {
        width: 100%;
        text-align: right;
        margin-bottom: 0 !important;
    }

    &__actions {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
    }

    &__filter {
        max-width: 200px;
    }

    &__reminder {
        border: 2px solid;
        border-radius: 15px;
        width: 100%;
        padding: 2px 10px;
        margin: 0 auto;
        background: #fff !important;
    }
}

::v-deep .v-data-table-header th {
    white-space: nowrap !important;
}

::v-deep .v-data-table-header th .v-data-table-header__content {
    display: flex !important;
    align-items: center;
    gap: 6px;
}
</style>
